import { Controller } from "@hotwired/stimulus"

// Panel lateral de filtros del historial de alertas. El pack V2 no carga el JS
// de Bootstrap, así que el abrir/cerrar es propio (misma técnica que
// `v2--modal`: una clase de visibilidad + bloqueo del scroll del body).
//
// El form vive SIEMPRE en el DOM, oculto: es un GET normal, así que sin JS el
// panel queda visible y sigue filtrando. Cerrar no borra lo escrito.
//
// Cierra SOLO el click deliberado en la X (regla v2-tables-modals): ni Esc ni
// backdrop. Elegir una sugerencia del autocompletado nativo de Chrome en un
// input aterriza el click detrás del desplegable (el backdrop) y manda un Esc
// al cerrarse, y ambos cerraban el panel en plena escritura (feedback
// 2026-09-21, campo Valor de las condiciones de payload).
//
// Además encadena traspaso → equipo: un equipo cuelga de un solo traspaso, y
// ofrecer los de otro es ofrecer una combinación que siempre da vacío. Las
// opciones traen `data-transfer-id`; el filtrado es local, sin ida al servidor.
export default class extends Controller {
  static targets = ["panel", "toggle", "transfer", "equip"]

  connect() {
    this.syncEquips()
  }

  disconnect() {
    document.body.classList.remove("tp-modal-open")
  }

  open() {
    this.panelTarget.classList.add("tp-filter-panel--open")
    document.body.classList.add("tp-modal-open")
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", "true")
    this.panelTarget.querySelector("select, input")?.focus()
  }

  close() {
    if (!this.panelTarget.classList.contains("tp-filter-panel--open")) return

    this.panelTarget.classList.remove("tp-filter-panel--open")
    document.body.classList.remove("tp-modal-open")
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "false")
      this.toggleTarget.focus()
    }
  }

  // Deja visibles solo los equipos del traspaso elegido. Sin traspaso, todos.
  // Si el equipo seleccionado ya no pertenece, se limpia: dejarlo puesto
  // filtraría por una intersección vacía sin que se vea por qué.
  syncEquips() {
    if (!this.hasTransferTarget || !this.hasEquipTarget) return

    const transferId = this.transferTarget.value
    let selectionLost = false

    for (const option of this.equipTarget.options) {
      const owner = option.dataset.transferId
      const belongs = !transferId || !owner || owner === transferId
      option.hidden = !belongs
      option.disabled = !belongs
      if (!belongs && option.selected) selectionLost = true
    }

    if (selectionLost) this.equipTarget.value = ""
  }
}
